import {
  RetailerNetworkScanDataLatestSubmissionsQuery,
  RetailerNetworkScanDataWeeklySubmissionFilter,
  useRetailerNetworkScanDataLatestSubmissionsQuery,
  RetailerNetworkScanDataLatestSubmissionsFragment,
} from '@occc/graphql';

const PAGE_SIZE = 5;

const transformToSubmissionsArray = (
  data: RetailerNetworkScanDataLatestSubmissionsQuery,
): RetailerNetworkScanDataLatestSubmissionsFragment[] => {
  const { edges } = data.retailerNetworkScanDataWeeklySubmissions;
  return edges?.map((item) => item.node) || [];
};

export const useRetailerNetworkScanDataTobaccoLatestSubmissions = (
  filter: RetailerNetworkScanDataWeeklySubmissionFilter,
) => {
  const response = useRetailerNetworkScanDataLatestSubmissionsQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    variables: {
      filter,
      first: PAGE_SIZE,
    },
  });

  return {
    ...response,
    data: response.data ? transformToSubmissionsArray(response.data) : response.data,
  };
};
